var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.visible,
          expression: "visible",
        },
      ],
      staticClass: "p-absolute top-0 right-0 bottom-0 left-0 bg-black-0-2",
    },
    [
      _c(
        "div",
        {
          staticClass:
            "p-absolute m-auto top-0 right-0 bottom-0 left-0 p-t-25 r-2 bg-white shadow-5-g-400 z-index-3",
          staticStyle: { width: "80%", height: "92%" },
        },
        [
          _c(
            "p",
            {
              staticStyle: {
                position: "absolute",
                top: "0",
                left: "0",
                "padding-top": "5px",
                "padding-left": "10px",
                width: "100%",
                "text-align": "left",
                color: "#653EB3",
                "font-size": "14px",
              },
            },
            [
              _vm._v(
                _vm._s(_vm.typeData.type === "ADD" ? "创建群聊" : "转发消息")
              ),
            ]
          ),
          _c("i", {
            staticClass:
              "el-icon-circle-close y-fc-999 p-absolute top-5 right-10 f-s-20 cursor-pointer",
            on: { click: _vm.close },
          }),
          _c(
            "div",
            {
              staticClass: "p-relative f-left h-100-p bg-white b-r b-c-150",
              staticStyle: { "padding-top": "51px", width: "300px" },
            },
            [
              _c("div", { staticClass: "p-absolute w-100-p top-0 left-0" }, [
                _c(
                  "div",
                  {
                    staticClass: "d-table p-x-12 w-100-p b-b b-c-g-100",
                    staticStyle: { height: "51px" },
                  },
                  [
                    _c("div", { staticClass: "d-table-cell v-a-middle" }, [
                      _c(
                        "label",
                        {
                          ref: "labelRef",
                          staticClass: "p-relative d-block h-30 bg-g-100",
                          staticStyle: { "border-radius": "15px" },
                        },
                        [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.value,
                                expression: "value",
                              },
                            ],
                            ref: "inputRef",
                            staticClass:
                              "form-element b-w-0 p-x-20 w-100-p h-30 l-h-30 bg-transparent",
                            attrs: { type: "text", placeholder: "搜索" },
                            domProps: { value: _vm.value },
                            on: {
                              focus: _vm.onFocusEventto,
                              input: function ($event) {
                                if ($event.target.composing) return
                                _vm.value = $event.target.value
                              },
                            },
                          }),
                          _c("i", {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.value,
                                expression: "value",
                              },
                            ],
                            staticClass:
                              "el-icon-close f-s-18 l-h-30 p-absolute top-0 bottom-0 right-0 m-auto p-x-10 cursor-pointer",
                            on: {
                              click: function ($event) {
                                $event.preventDefault()
                                return _vm.clearValue.apply(null, arguments)
                              },
                            },
                          }),
                        ]
                      ),
                    ]),
                  ]
                ),
              ]),
              _c(
                "div",
                { staticClass: "h-100-p o-auto" },
                [
                  _vm.kecontactItems.length > 0
                    ? _c("im-toGroupContact-list", {
                        key: Math.random(),
                        attrs: {
                          width: _vm.imAsideLeft,
                          items: _vm.kecontactItems,
                        },
                        on: { createSession: _vm.createSession },
                      })
                    : _vm._e(),
                ],
                1
              ),
              _vm.toGroupVisible
                ? _c("im-contact-select-togroup", {
                    ref: "contactSelectRef",
                    attrs: {
                      forwordTeamList: _vm.forwordTeamList,
                      reverseDelSession: _vm.reverseDelSession,
                      showSelectedStatus: _vm.showSelectedStatus,
                      id: _vm.id,
                      typeData: _vm.typeData,
                      value: _vm.value,
                      togroup: _vm.togroup,
                      visible: _vm.visible,
                    },
                    on: {
                      createSession: _vm.createSession,
                      delSelectedSession: _vm.delSelectedSession,
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
          _c("div", { staticClass: "h-100-p o-auto" }, [
            _c(
              "div",
              {
                staticClass: "p-relative p-x-15 p-t-25 h-100-p",
                staticStyle: { "padding-bottom": "120px" },
              },
              [
                _c(
                  "p",
                  {
                    staticClass:
                      "p-absolute top-0 left-0 p-l-15 w-100-p f-s-14",
                  },
                  [
                    _vm._v("已选择成员 "),
                    _c("span", { staticClass: "c-blue" }, [
                      _vm._v(_vm._s(_vm.items.length)),
                    ]),
                    _vm._v("/" + _vm._s(_vm.teamlevel - 1)),
                  ]
                ),
                _c(
                  "div",
                  { staticClass: "h-100-p o-auto" },
                  [
                    _c("im-contact-list-group", {
                      ref: "imContactListGroupRef",
                      attrs: { items: _vm.items },
                      on: {
                        reverseDelSelectedSession:
                          _vm.reverseDelSelectedSession,
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  {
                    staticClass: "p-absolute bottom-0 left-0 w-100-p p-x-20",
                    staticStyle: { height: "120px" },
                  },
                  [
                    _vm.typeData.type === "ADD"
                      ? _c("p", [
                          _c("span", { staticClass: "c-red" }, [_vm._v("* ")]),
                          _vm._v("设置群名称："),
                        ])
                      : _vm._e(),
                    _vm.typeData.type === "ADD"
                      ? _c("div", [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.groupName,
                                expression: "groupName",
                              },
                            ],
                            staticClass: "form-element w-100-p m-t-8",
                            attrs: {
                              type: "text",
                              maxlength: "30",
                              placeholder: "请输入群名称，字符长度30以内",
                            },
                            domProps: { value: _vm.groupName },
                            on: {
                              input: [
                                function ($event) {
                                  if ($event.target.composing) return
                                  _vm.groupName = $event.target.value
                                },
                                _vm.groupNameInputEvent,
                              ],
                            },
                          }),
                        ])
                      : _vm._e(),
                    _vm.typeData.type === "FORWORD"
                      ? _c("div", [
                          _c("textarea", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.leaveMessage,
                                expression: "leaveMessage",
                              },
                            ],
                            staticClass: "form-element w-100-p m-t-8",
                            attrs: {
                              type: "text",
                              maxlength: "500",
                              placeholder: "给对方留言",
                            },
                            domProps: { value: _vm.leaveMessage },
                            on: {
                              input: function ($event) {
                                if ($event.target.composing) return
                                _vm.leaveMessage = $event.target.value
                              },
                            },
                          }),
                        ])
                      : _vm._e(),
                    _c("div", { staticClass: "t-a-right p-t-10" }, [
                      _c(
                        "button",
                        {
                          staticClass: "button m-r-10",
                          attrs: { type: "button" },
                          on: { click: _vm.close },
                        },
                        [_vm._v("取消")]
                      ),
                      _vm.typeData.type === "ADD"
                        ? _c(
                            "button",
                            {
                              staticClass: "button button-blue",
                              attrs: {
                                type: "button",
                                disabled: _vm.disabledCp,
                              },
                              on: { click: _vm.createTeam },
                            },
                            [_vm._v("确定")]
                          )
                        : _vm._e(),
                      _vm.typeData.type === "FORWORD"
                        ? _c(
                            "button",
                            {
                              staticClass: "button button-blue",
                              attrs: {
                                type: "button",
                                disabled: _vm.disabledCp,
                              },
                              on: { click: _vm.forwardSend },
                            },
                            [_vm._v("发送")]
                          )
                        : _vm._e(),
                    ]),
                  ]
                ),
              ]
            ),
          ]),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }